<template>
    <div class="appVersion">
        <div>
            <form :form="form" @submit.prevent="query">
                <div style="display: flex;justify-content: space-between;align-items: center;">
                    <div class="logQuery">
                        <InputField label="" label-width="0" style="margin: 0.1rem 0.5rem 0.1rem 0;width:50%" type="text" id="name" v-model="form.name" placeholder="泵站名称"
                                    @update:modelValue="(value) => handleModelValueUpdate('name', value)"
                        />
                        <a-space style="margin: 0 0 0 0.5rem;width:25%">
                            <ButtonField text="查询" @click="query" secondary />
                            <ButtonField text="重置" primary @click="reset"/>
                            <ButtonField text="导出" @click="exportExcel" secondary />
                        </a-space>
                    </div>
                    <div class="right">
                        <ButtonField text="新建" @click="$emit('show-pump-add')" secondary />
                    </div>
                </div>
            </form>
        </div>
        <Tablelist
            style="margin-top: 1rem"
            :showCheckbox="false"
            :list="list"
            :totalSize="totalSize"
            :totalPages="totalPages"
            :pageNum="pageNum"
            :pageSize="pageSize"
            :columns="tableColumns"
            @page-change="onChange"
        >
            <template v-slot:actions="{ item }">
                <a-space>
                    <a href="#" @click.prevent="$emit('show-pump-edit',item.id)">编辑</a>
                    <a href="#" class="danger" @click.prevent="deleteText(item)">删除</a>
                </a-space>
            </template>
        </Tablelist>
    </div>
</template>
<script>
import * as XLSX from 'xlsx';
import { pumpList, remove } from "../api/pipe-info.js";
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            form: {},
            list: [],
            loading: false,
            total: 0,
            totalSize: 0,
            totalPages: 0,
            pageNum: 1,
            pageSize: 10,
            tableColumns: [
                { key: 'id', title: '泵站ID', field: 'id', infotype: 'text' },
                { key: 'name', title: '泵站名称', field: 'name', infotype: 'text',width: '150px'},
                { key: 'operation', title: '运行情况', field: 'operation', infotype: 'text',width: '250px' },
                { key: 'scale', title: '规划规模（万吨/日）', field: 'scale', infotype: 'text',width: '120px'},
                { key: 'power', title: '功率(KW)', field: 'power', infotype: 'text',width: '150px'},
                { key: 'location', title: '位置', field: 'location', infotype: 'text',width: '150px'},
                { key: 'remark', title: '备注', field: 'remark', infotype: 'text' },
                { key: 'actions', title: '操作', infotype: 'template', width: '150px', fixed: 'right' },
            ],
            createAtList: this.generateYearList(1990, new Date().getFullYear())
        };
    },
    mounted() {
        this.getList();
    },
    computed: {
        ...mapGetters("setting", ["findDataDict"]),
        statusList() {
            return this.findDataDict("AssetReviewStatus");
        },
        typeList() {
            return this.findDataDict("pipeType");
        },
    },
    methods: {
        exportExcel() {
            this.loading = true; // 显示加载状态
            const { form } = this;
            // 请求所有数据：pageNum=1，pageSize设为极大值（如10000）确保获取全部
            pumpList({
                pageNum: 1,
                pageSize: 10000,
                ...form
            })
                .then((res) => {
                    console.log("API返回数据：", res);
                    this.loading = false;
                    if (Array.isArray(res.list) && res.list.length > 0) {
                        const excelData = this.formatExcelData(res.list);
                        this.downloadExcel(excelData, "雨水井数据");
                    } else {
                        this.$message.warning("暂无数据可导出");
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("导出失败", error);
                    this.$message.error("导出失败，请重试");
                });
        },
        formatExcelData(rawList) {
            const excelHeaders = [
                { key: 'name', title: '泵站名称'},
                { key: 'operation', title: '运行情况' },
                { key: 'scale', title: '规划规模（万吨/日）'},
                { key: 'power', title: '功率(KW)' },
                { key: 'location', title: '位置' },
                { key: 'remark', title: '备注' }
            ];

            console.log("原始数据：", rawList);

            const formattedData = rawList.map(item => {
                const row = {};
                excelHeaders.forEach(header => {
                    row[header.title] = item[header.key] || "";
                });
                return row;
            });

            console.log("格式化后的数据：", formattedData);
            return formattedData; // 直接返回数据数组，不包含额外的表头行
        },
        downloadExcel(data, fileName) {
            try {
                const workbook = XLSX.utils.book_new();
                const worksheet = XLSX.utils.json_to_sheet(data);

                XLSX.utils.book_append_sheet(workbook, worksheet, "数据列表");

                const date = new Date().toLocaleDateString().replace(/\//g, "-");
                const fullFileName = `${fileName}_${date}.xlsx`;

                XLSX.writeFile(workbook, fullFileName);

                console.log("生成的文件名：", fullFileName);
            } catch (error) {
                console.error("下载Excel失败", error);
                this.$message.error("下载Excel失败，请重试");
            }
        },
        generateYearList(startYear, endYear) {
            const years = [];
            for (let year = endYear; year >= startYear; year--) {
                years.push({ name: year.toString(), value: year.toString() });
            }
            return years;
        },
        handleModelValueUpdate(fieldName, value) {
            this.form[fieldName] = value;
        },
        getList() {
            this.loading = true;
            let { form } = this;
            form.code = this.form.code;
            form.location = this.form.location;
            pumpList({
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                ...form,
            })
                .then((res) => {
                    this.loading = false;
                    if (Array.isArray(res.list)) {
                        this.list = res.list;
                        this.totalSize = res.totalSize;
                        this.totalPages = res.totalPages;
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("获取数据失败", error);
                    this.$message.error("获取数据失败，请重试");
                });
        },
        onChange(pagination) {
            this.pageNum = pagination;
            this.pageSize = 10;
            this.getList();
        },
        reset() {
            this.form = {};
            this.pageNum = 1;
            this.pageSize = 10;
            this.getList();
        },
        query() {
            this.pageSize = 10;
            this.getList();
        },
        deleteText(text) {
            const that = this;
            this.$confirm({
                title: "确认要删除吗？",
                onOk() {
                    remove({
                        id: text.id,
                        type: 'rain_well'
                    }).then(() => {
                        that.getList();
                    }).catch((error) => {
                        console.error("删除失败", error);
                        that.$message.error("删除失败，请重试");
                    });
                },
            });
        },
    },
};
</script>
<style lang="less" scoped>
.logQuery{
    display: flex;
    justify-content: start;
}
.right ::v-deep Button{
    margin: 0 0.2rem;
}
</style>